import React, { useState, useEffect } from 'react'

import { Dialog } from "@progress/kendo-react-dialogs";
// import { Grid, GridColumn } from '@progress/kendo-react-grid';
// import DataList from '../DataList';


const CustomTitleBar = ({ tikNum, dialogTitleData }) => {
  return (
    <div>
      <div>
        <span>{`מערכת ${dialogTitleData.systemName} `}</span>
        <span>|</span>
        <span>{` תיק ${tikNum} `}</span>
        <span>|</span>
        {
          dialogTitleData.stepCodeText ? 
            <span>{` ${dialogTitleData.stepCodeText}`}</span>
            :
            ""
        }
      </div>
      <div>
        <span>
          {
            dialogTitleData.sugHahlata ? 
              <b>{`${dialogTitleData.sugHahlata} מתאריך `}</b>
              :
              ""
          }
          {`${dialogTitleData.diunDate}: ${dialogTitleData.hahlataText ? dialogTitleData.hahlataText : ""}`}
        </span>
        <br />        
        {
          dialogTitleData.tokefDate ?
            <span>
              <b>{`תום תוקף החלטה: `}</b>
              {`${dialogTitleData.tokefDate}`}
            </span>
            :
            ""
        }
      </div>
    </div>
  );
};

const TikDetailsDialog = ({ dialogData, tikNum, toggleDialog }) => {
  dialogData.tikNum = tikNum;
  const [dialogTitle, setDialogTitle] = useState({});

  useEffect(() => {
    setDialogTitle({
      systemName: dialogData.systemText,
      stepCodeText: dialogData.stepCodeText,
      sugHahlata: dialogData.sugReshumaHahlata,
      diunDate: dialogData.taarihDiun,
      hahlataText: dialogData.hahlataText,
      tokefDate: dialogData.taarihTokefHahlata
    })
  }, [dialogData, tikNum])
  

  return (
    <Dialog
      title={<CustomTitleBar tikNum={dialogData.tikNum} dialogTitleData={dialogTitle} />}
      width={"800px"}
      height={"500px"}
      onClose={() => toggleDialog()}
    >
       <div style={{ textAlign: "right" }} dangerouslySetInnerHTML={{ __html: dialogData.hamlatzaTochen }} />
    </Dialog>
  )
}

export default TikDetailsDialog;